import { ContentSchedule } from '@/tools/models/class-builder.models';

export class SyncBuilderDataRequest {
  builderId?: number;
  templateId?: number;
  contentId?: number;
  version?: number;
  header?: any;
  objectsDetail?: any;
  contentStructure?: ContentStructureRequest;
  scheduleType?: string;
  scheduleShortDay?: string;
  schedule?: ContentSchedule[];
  translateIds?: boolean = true;
  publish?: boolean = false;
  specialDays?: any[];
  workingDays?: any[];
  saveCoverImage?: boolean;
}

export class ContentStructureRequest {
  structureSections : StructureSections[];
  structureChanges  : StructureRequest[];
  
  constructor(structureSections: StructureSections[], structureChanges: StructureRequest[]) {
    this.structureSections = structureSections;
    this.structureChanges = structureChanges;
  }
}

export class StructureSections {
  type            : string;
  name            : string;
  text            : string;
  temporalId      : string;
  
  constructor(temporalId: string, type: string, name: string, text: string) {
    this.temporalId = temporalId;
    this.type = type;
    this.name = name;
    this.text = text;
  }
}

export class StructureRequest {
  sectionId       : number;
  parentId        : number;
  order           : number = 0;
  fixedSequence?  : number = 0;
  startSchoolDay? : number;
  endSchoolDay?   : number;   
  fixedDate?      : boolean;
  
  constructor(sectionId: number, parentId: number, order: number = 0, fixedSequence?: number, startSchoolDay?: number, endSchoolDay?: number, fixedDate: boolean = false) {
    this.sectionId = sectionId;
    this.parentId = parentId;
    this.order = order;
    this.fixedSequence = fixedSequence;
    this.startSchoolDay = startSchoolDay;
    this.endSchoolDay = endSchoolDay;
    this.fixedDate = fixedDate
  }
}